'use client';

import { usePriceAndFitmentContext } from 'app/[lang]/[esite]/contexts/price-and-fitment-context/price-and-fitment-context';
import styles from './product-tax-disclaimer-message.module.scss';
import { Conditional } from '@cat-ecom/pcc-components';
import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import { DealerPriceAvailabilityResponse } from 'services/dealerPriceAvailability/types';

interface ProductTaxDisclaimerMessageProps {
  includedMessage: string;
  excludedMessage: string;
}

const ProductTaxDisclaimerMessage = ({
  includedMessage,
  excludedMessage
}: ProductTaxDisclaimerMessageProps) => {
  const { priceAndAvailability } = usePriceAndFitmentContext();
  const { isGstIncludesTax } =
    (priceAndAvailability as DealerPriceAvailabilityResponse) ?? {};
  const disclaimerMessage = isGstIncludesTax
    ? includedMessage
    : excludedMessage;

  return (
    <Conditional test={!isEmpty(disclaimerMessage)}>
      <footer
        data-testid="tax-diclaimer-footer"
        className={`${styles['gst-information-footer']} d-flex flex-row gap-1 fst-italic px-md-0 px-2 cat-u-theme-typography-footnote cat-u-padding-top-xl cat-u-padding-bottom-md`}
      >
        <span className="mb-0 cat-u-theme-typography-footnote">&dagger;</span>
        <p className="mb-0 cat-u-theme-typography-footnote">
          {disclaimerMessage}
        </p>
      </footer>
    </Conditional>
  );
};

export default ProductTaxDisclaimerMessage;
